import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { ConfigService } from '../services/config/config.service';

// Match api.finnair.com, api-test.finnair.com etc
const URL_MATCHER = /api(-\w+)?\.finnair\.com/;

@Injectable({
  providedIn: 'root',
})
export class WithCredentialsInterceptor implements HttpInterceptor {
  private configService = inject(ConfigService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this.configService.cfg.forceWithCredentials || !this.isApiCall(req)) {
      return next.handle(req);
    }

    return next.handle(req.clone({ withCredentials: true }));
  }

  private isApiCall(req: HttpRequest<unknown>): boolean {
    return URL_MATCHER.test(req.url);
  }
}
